/// <amd-module name="SuiteCommerce.FeaturedCategory.EntryPoint"/>
define("SuiteCommerce.FeaturedCategory.EntryPoint", ["require", "exports", "SuiteCommerce.FeaturedCategory.FeaturedCategory", "SuiteCommerce.FeaturedCategory.Common.Configuration", "SuiteCommerce.FeaturedCategory.Common.Utils"], function (require, exports, FeaturedCategory_1, Configuration_1, Utils_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            var environment = container.getComponent('Environment');
            var userProfile = container.getComponent('UserProfile');
            if (userProfile) {
                userProfile
                    .getUserProfile()
                    .then(function (userProfileData) {
                    Utils_1.Utils.userProfileData = userProfileData;
                });
            }
            
            this.initializeConfiguration(environment);
            FeaturedCategory_1.FeaturedCategoryModuleCCT.mountToApp(container);
        },
        initializeConfiguration: function (environment) {
            Configuration_1.Configuration.environment = environment;
        }
    };
});
